import { useContext } from 'react';
import { EnvironmentUrls, EnvironmentUrlsContext } from './EnvironmentUrlsContext';

export default function useEnvironmentUrls(): EnvironmentUrls {
  const environmentUrls = useContext(EnvironmentUrlsContext);

  if (!environmentUrls) {
    throw new Error("useEnvironmentUrls: no EnvironmentUrlsProvider mounted. Mount <SharedProviders> (from 'shared').");
  }

  return environmentUrls;
}
